// These large barrel exports cause circular dependency issues. We need to avoid using them.
console.warn('Used deprecated barrel export');

/*
 * Public API Surface of suvo-bi-client-lib
 */

export * from './lib/suvo-bi-client-lib.module';

/*  Shared
 */
export * from './lib/shared/interfaces/bi-link.interface';
export * from './lib/shared/interfaces/table-service.interface';
export * from './lib/shared/interfaces/table-data-source.interface';
export * from './lib/shared/faqs/interfaces/faqs.interface';
export * from './lib/shared/interfaces/table-service.interface';

export * from './lib/shared/constants/countries.constant';

export * from './lib/shared/modules/angular-material/angular-material.module';
export * from './lib/shared/shared.module';
export * from './lib/shared/faqs/faqs.module';
export * from './lib/shared/visualisations/visualizations.module';

export * from './lib/shared/faqs/components/faqs.component';
export * from './lib/shared/logo/logo.component';
export * from './lib/shared/visualisations/components/nice-card/nice-card.component';

export * from './lib/shared/services/api.service';
export * from './lib/shared/services/snack/snack-bar.service';

/*  Toggle Group Navigation
 */
export * from './lib/features/toggle-group-navigation/toggle-group-navigation.module';
export * from './lib/features/toggle-group-navigation/components/toggle-group-navigation/toggle-group-navigation.component';

/*  List Navigation
 */
export * from './lib/features/list-navigation/list-navigation.module';
export * from './lib/features/list-navigation/components/list-navigation/list-navigation.component';

/* Account Sidenav Widget
 */
export * from './lib/features/account-sidenav-widget/account-sidenav-widget.module';
export * from './lib/features/account-sidenav-widget/components/account-sidenav-widget/account-sidenav-widget.component';

/*  Tour
 */
export * from './lib/features/tour/tour.module';
export * from './lib/features/tour/components/tour-outlet/tour-outlet.component';
export * from './lib/features/tour/interfaces/tour.interface';
export * from './lib/features/tour/services/tour.service';

/*  Manage Identity
 */
export * from './lib/features/manage-bi-identity/manage-bi-identity.module';
export * from './lib/features/manage-bi-organisations/manage-bi-organisations.module';
export * from './lib/features/manage-bi-shared/manage-bi-shared.module';

/* Email Alerts
 */
export * from './lib/features/email-alert/services/email-alert.service';
export * from './lib/features/email-alert/email-alert.module';

/*  Data Source
 */
export * from './lib/features/data-source/data-source.module';
export * from './lib/features/data-source/data-source-items/modules/data-source-items.module';
export * from './lib/features/data-source/data-source-items/services/data-source-items.service';
export * from './lib/features/filters/services/filters-api.service';

// Data source definitions

// Import definition
export * from './lib/features/import-definition';

// CSV parse
export * from './lib/features/csv-parse';

//// Modules
export * from './lib/features/data-source/data-source-definitions/modules/data-source-definitions.module';

//// Services
export * from './lib/features/data-source/data-source-definitions/services/data-source-definitions.service';
export * from './lib/features/data-source/data-source-definitions/services/data-source-properties.service';
export * from './lib/features/data-source/data-source-definitions/services/new-data-source-definitions.service';

export * from './lib/features/data-source/data-source-definitions/interfaces/data-source-definition-property-type.enum';

/*  Filters
 */
export * from './lib/features/filters/filters.module';
export * from './lib/features/filters/components/control/filters-sidenav/filters-sidenav.component';
export * from './lib/features/filters/components/control/filters-accordion/filters-accordion.component';
export * from './lib/features/filters/components/filter-widgets/active-filters-widget/active-filters-widget.component';
export * from './lib/features/filters/components/filter-widgets/filter-widgets.module';
export * from './lib/features/filters/services/filters-sidenav.service';
export * from './lib/features/filters/services/filters-channels.service';
export * from './lib/features/filters/models/filters-channel.model';
export * from './lib/features/filters/models/filters.model';
export * from './lib/shared/interfaces/filters/filters.interface';
export * from './lib/shared/interfaces/filters/filter-rule.type';
export * from './lib/shared/interfaces/filters/filter-property.interface';
export * from './lib/shared/interfaces/filters/filter-operator-type.enum';
export * from './lib/shared/interfaces/filters/filter-group.interface';
export * from './lib/shared/interfaces/filters/filter-condition.interface';
export * from './lib/shared/interfaces/filters/filter-condition-type.enum';

export * from './lib/features/filters/guards/unsaved-changes.guard';
/*  Favourites
 */
export * from './lib/features/data-source/data-source-favourites/data-source-favourites.module';
export * from './lib/features/data-source/data-source-favourites/services/data-source-favourites.service';
export * from './lib/features/data-source/data-source-favourites/components/widgets/favourite-item-star/favourite-item-star.component';
export * from './lib/features/data-source/data-source-favourites/components/favourite-items-table/favourite-items-table.component';

/*  Route Selector
 */
export * from './lib/features/route-selector/route-selector.module';
export * from './lib/features/route-selector/components/route-selector/route-selector.component';

/* Session
 */
export * from './lib/shared/services/session.service';

/* Smart Grid
 */
export * from './lib/features/smart-grid/smart-grid.module';
export * from './lib/features/smart-grid/interfaces/grid-settings.interfaces';

/* Dashboards
 */
export * from './lib/features/dashboards/dashboards.module';
export * from './lib/features/dashboards/models/dashboard.model';
export * from './lib/features/dashboards/services/dashboards.service';
export * from './lib/features/dashboards/interfaces/latest-drafts-pagination-response.interface';
export * from './lib/features/dashboards/services/filter-demo-tour.service';
export * from './lib/features/dashboards/services/dashboards-settings.service';
export * from './lib/features/dashboards/components/dashboards/dashboard/dashboard.component';

// Tables
export * from './lib/features/tables/tables.module';
export * from './lib/features/data-source/data-source-items/interfaces/items-table-options.interface';

// User Settings
export * from './lib/features/user-settings/user-settings.module';
export * from './lib/features/user-settings/services/user-settings.service';

/* Side nav
 */
export * from './lib/shared/interfaces/sidenav-state.interface';

/* Sitemap
 */
export * from './lib/shared/sitemap/interfaces/confirm-dialog-data.interface';
export * from './lib/shared/sitemap/interfaces/sitemap-route-flat-node.interface';
export * from './lib/shared/sitemap/interfaces/sitemap-route-node-update.interface';
export * from './lib/shared/sitemap/interfaces/sitemap-route-node.interface';
export * from './lib/shared/sitemap/interfaces/sitemap-route.interface';
export * from './lib/shared/sitemap/interfaces/sitemap-tree.interface';

export * from './lib/shared/sitemap/models/sitemap-route.model';
export * from './lib/shared/sitemap/models/sitemap-tree.model';

/* UI Components
 */
export * from './lib/shared/ui-components/ui-components.module';

export * from './lib/features/dashboards';
